import { render, staticRenderFns } from "./ProceedingsPaperPage.vue?vue&type=template&id=c2fe9646&scoped=true"
import script from "./ProceedingsPaperPage.vue?vue&type=script&lang=js"
export * from "./ProceedingsPaperPage.vue?vue&type=script&lang=js"
import style0 from "./ProceedingsPaperPage.vue?vue&type=style&index=0&id=c2fe9646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fe9646",
  null
  
)

export default component.exports